<template>
    <div class="wrapper">
        <LoadingSpinner v-show="loading" />
        <template v-if="notifications.length > 0">
            <transition-group name="notification-list" tag="div" class="notifications" appear>
                <notification
                    appear
                    v-for="(notification, idx) in notifications"
                    :key="idx"
                    :notification="notification"
                ></notification>
            </transition-group>
        </template>
        <div class="form-card verify-email" v-if="shownCard === 'verifyEmail'">
            <div class="verify-email--inner">
                <form @submit.prevent="login" v-if="hasConfirmationToken">
                    <h2>Varmistautuminen onnistui</h2>
                    <p>Kirjaudu sisään viimeistelläksesi rekisteröitymisen.</p>
                    <section>
                        <label for="verify-login--email">
                            <span>Email:</span>
                            <abbr title="required" aria-label="required">*</abbr>
                        </label>
                        <input
                            id="verify-login---email"
                            name="email"
                            type="email"
                            v-model.trim="loginCreds.email"
                            autofocus
                            required
                        />
                    </section>
                    <section>
                        <label for="verify-login--password">
                            <span>Salasana:</span>
                            <abbr title="required" aria-label="required">*</abbr>
                        </label>
                        <input
                            type="password"
                            ref="passwordField"
                            id="verify-login--password"
                            name="current-password"
                            v-model="loginCreds.password"
                            autofocus
                            required
                        />
                        <button
                            class="eye-icon"
                            type="button"
                            id="toggle-password"
                            aria-label="Show password"
                            @click.prevent="togglePassword"
                            ref="togglePassword"
                        >
                            <font-awesome-icon :icon="eyeIcon" />
                        </button>
                    </section>

                    <button type="submit" class="submit-button">Kirjaudu sisään</button>
                </form>
                <div v-else>
                    <h2>Varmista sähköpostisi</h2>
                    <p>
                        Sähköpostiisi on lähetetty varmistamisviesti. Varmista sähköpostisi, jotta voit kirjautua
                        käyttäjllä.
                    </p>
                </div>
                <p class="sign-up-link">
                    Haluatko kirjautua toisella käyttäjällä?
                    <span @click="toggleVerifyEmail">Kirjautuminen</span>
                </p>
            </div>
        </div>
        <div class="form-card recover-account" v-else-if="shownCard === 'recoverAccount'">
            <div class="verify-email--inner">
                <form @submit.prevent="updatePassword" v-if="hasRecoveryToken && currentUser">
                    <h2>Palauta salasana</h2>
                    <p>
                        Vaihda salasana
                    </p>

                    <section>
                        <label for="update-password--password">
                            <span>Uusi salasana:</span>
                            <abbr title="required" aria-label="required">*</abbr>
                        </label>
                        <input
                            type="password"
                            ref="passwordField"
                            id="update-password--password"
                            name="new-password"
                            v-model="updatePasswordCreds.password"
                            autofocus
                            required
                        />
                        <button
                            class="eye-icon"
                            type="button"
                            id="toggle-password"
                            aria-label="Show password"
                            @click.prevent="togglePassword"
                            ref="togglePassword"
                        >
                            <font-awesome-icon :icon="eyeIcon" />
                        </button>
                    </section>

                    <button type="submit" class="submit-button">
                        Vaihda salasana
                    </button>
                </form>
                <div v-else-if="hasRecoveryToken && !currentUser" class="mb-10">
                    <h2>Palauta salasana</h2>
                    <p>Odota hetki...</p>
                </div>
                <div v-else-if="isSentRequest" class="mb-10">
                    <h2>Palauta salasana</h2>
                    <p>Sähköpostiisi on lähetetty palautuslinkki.</p>
                </div>
                <form @submit.prevent="recoveryRequest" v-else>
                    <h2>Palauta salasana</h2>
                    <p>
                        Jos olet unohtanut käyttäjäsi salasanan, lähetämme sinulle sähköpostiin palautuslinkin.
                    </p>

                    <section>
                        <label for="recover-account--email">
                            <span>Sähköposti:</span>
                            <abbr title="required" aria-label="required">*</abbr>
                        </label>
                        <input
                            type="email"
                            id="recover-account--email"
                            name="email"
                            v-model="recoverCreds.email"
                            autofocus
                            required
                        />
                    </section>

                    <button type="submit" class="submit-button">
                        Lähetä palautuslinkki
                    </button>
                </form>
                <p class="sign-up-link">
                    Haluatko kirjautua toisella käyttäjällä?
                    <span @click="toggleRecoverAccount">Kirjautuminen</span>
                </p>
            </div>
        </div>
        <div class="form-card login-screen" v-else>
            <div>
                <span>Karanteeni Ylläpito</span>
            </div>
            <form @submit.prevent="loginAsDefault" v-if="isDefaultLogin">
                <h2>Kirjaudu sisään ylläpitäjänä</h2>

                <section>
                    <label for="default-login--password">
                        <span>Salasana:</span>
                        <abbr title="required" aria-label="required">*</abbr>
                    </label>
                    <input
                        type="password"
                        ref="passwordField"
                        id="default-login--password"
                        name="current-password"
                        v-model="loginCreds.password"
                        autofocus
                        required
                    />
                    <button
                        class="eye-icon"
                        type="button"
                        id="toggle-password"
                        aria-label="Show password"
                        @click.prevent="togglePassword"
                        ref="togglePassword"
                    >
                        <font-awesome-icon :icon="eyeIcon" />
                    </button>
                </section>

                <button type="submit" class="submit-button">Kirjaudu sisään</button>
                <p class="reminder">(salasanan voi pyytää Susselta Susse#9999)</p>
            </form>
            <form @submit.prevent="login" v-else-if="!isDefaultLogin && isLogin">
                <h2>Kirjaudu sisään</h2>

                <section>
                    <label for="login--email">
                        <span>Email:</span>
                        <abbr title="required" aria-label="required">*</abbr>
                    </label>
                    <input
                        id="login---email"
                        name="email"
                        type="email"
                        v-model.trim="loginCreds.email"
                        autofocus
                        required
                    />
                </section>
                <section>
                    <label for="login--password">
                        <span>Salasana:</span>
                        <abbr title="required" aria-label="required">*</abbr>
                    </label>
                    <input
                        type="password"
                        ref="passwordField"
                        id="login--password"
                        name="current-password"
                        v-model="loginCreds.password"
                        required
                    />
                    <button
                        class="eye-icon"
                        type="button"
                        id="toggle-password"
                        aria-label="Show password"
                        @click.prevent="togglePassword"
                        ref="togglePassword"
                    >
                        <font-awesome-icon :icon="eyeIcon" />
                    </button>
                </section>

                <button type="submit" class="submit-button">Kirjaudu sisään</button>
                <p class="sign-up-link">
                    Haluatko kirjautua yleiskäyttäjällä?
                    <span @click="toggleDefaultLogin">Yleiskirjautuminen</span>
                </p>
                <p class="sign-up-link">
                    Tarvitsetko käyttäjän?
                    <span @click="toggleSignup">Luo käyttäjä</span>
                </p>
                <p class="sign-up-link">
                    Unohtuiko salasana?
                    <span @click="toggleRecoverAccount">Palauta salasana</span>
                </p>
            </form>
            <form @submit.prevent="signup" v-else>
                <h2>Luo käyttäjä</h2>

                <section>
                    <label for="signup--email"
                        ><span>Email:</span>
                        <abbr title="required" aria-label="required">*</abbr>
                    </label>
                    <input
                        id="signup--email"
                        name="email"
                        type="email"
                        v-model.trim="signupCreds.email"
                        autofocus
                        required
                    />
                </section>
                <section>
                    <label for="signup--password">
                        <span>Salasana:</span>
                        <abbr title="required" aria-label="required">*</abbr>
                    </label>
                    <input
                        @click.prevent.left
                        type="password"
                        ref="passwordField"
                        id="signup--password"
                        name="new-password"
                        v-model="signupCreds.password"
                        required
                    />
                    <button
                        class="eye-icon"
                        type="button"
                        id="toggle-password"
                        aria-label="Show password"
                        @click.prevent="togglePassword"
                        ref="togglePassword"
                    >
                        <font-awesome-icon :icon="eyeIcon" />
                    </button>
                </section>

                <button type="submit" class="submit-button">luo käyttäjä</button>
                <p class="sign-up-link">
                    Onko sinulla jo käyttäjä?
                    <span @click="toggleSignup">Kirjaudu sisään.</span>
                </p>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Notification from './Notification'
import LoadingSpinner from './Loading.vue'

export default {
    name: 'Login',
    components: {
        Notification,
        LoadingSpinner
    },
    data() {
        return {
            auth: null,
            isLogin: true,
            isDefaultLogin: true,
            isVerifyEmail: false,
            isRecoverAccount: false,
            isSentRequest: false,
            loading: false,
            showPassword: false,
            hasRecoveryToken: false,
            hasConfirmationToken: false,
            loginCreds: {
                email: null,
                password: null
            },
            signupCreds: {
                email: null,
                password: null
            },
            updatePasswordCreds: {
                password: null
            },
            recoverCreds: {
                email: null
            },
            eyeIcon: 'eye'
        }
    },
    computed: {
        ...mapState('auth', ['notifications', 'currentUser']),
        shownCard() {
            if (this.isVerifyEmail) {
                return 'verifyEmail'
            } else if (this.isRecoverAccount) {
                return 'recoverAccount'
            } else {
                return 'login'
            }
        }
    },
    methods: {
        ...mapActions('auth', [
            'attemptLogin',
            'attemptSignUp',
            'addNotification',
            'attemptRecovery',
            'attemptUpdatePassword',
            'attemptRecoveryRequest'
        ]),
        toggleDefaultLogin() {
            this.isDefaultLogin = !this.isDefaultLogin
        },
        toggleVerifyEmail() {
            this.isVerifyEmail = !this.isVerifyEmail
        },
        toggleSignup() {
            this.isLogin = !this.isLogin
        },
        toggleRecoverAccount() {
            this.isRecoverAccount = !this.isRecoverAccount
            this.hasRecoveryToken = false
            this.isSentRequest = false
        },
        togglePassword(e) {
            if (this.showPassword) {
                this.$refs.passwordField.type = 'password'
                this.$refs.togglePassword.setAttribute('aria-label', 'Show password')
                this.showPassword = false
                this.eyeIcon = 'eye'
            } else {
                this.$refs.passwordField.type = 'text'
                this.$refs.togglePassword.setAttribute('aria-label', 'Hide password')
                this.showPassword = true
                this.eyeIcon = 'eye-slash'
            }
        },
        signup() {
            this.loading = true
            this.attemptSignUp(this.signupCreds)
                .then(() => {
                    this.loading = false
                    this.addNotification({
                        title: 'Sign Up',
                        text: 'Rekisteröidyit onnistuneesti. Sähköpostiisi on lähetetty varmistusviesti.',
                        type: 'success'
                    })
                    this.toggleVerifyEmail()
                })
                .catch((err) => {
                    this.loading = false
                    console.error(err)
                    this.handleUnsuccessfulLogin(err)
                })
        },
        updatePassword() {
            if (!this.updatePasswordCreds.password || this.updatePasswordCreds.password.length < 8) {
                this.addNotification({
                    title: 'Puuttuvat tiedot',
                    text: 'Liian lyhyt salasana. Salasanan pituus vähintään 8 merkkiä.',
                    type: 'fail'
                })
                return
            }

            this.loading = true

            this.attemptUpdatePassword({ ...this.updatePasswordCreds })
                .then(() => {
                    this.toggleRecoverAccount()
                    this.handleSuccessfulLogin()
                })
                .catch((err) => {
                    this.handleUnsuccessfulLogin(err)
                })
        },
        recoveryRequest() {
            this.loading = true
            this.attemptRecoveryRequest({ ...this.recoverCreds })
                .then(() => {
                    this.loading = false
                    // TODOOOOOOOO
                    this.isSentRequest = true
                })
                .catch((err) => {
                    this.handleUnsuccessfulLogin(err)
                })
        },
        recover(token) {
            this.loading = true
            this.attemptRecovery({ token })
                .then(() => {
                    this.handleSuccessfulRecovery()
                    this.currentUser
                })
                .catch((err) => {
                    console.error(err)
                    this.handleUnsuccessfulRecovery(err)
                })
        },
        login(data) {
            this.loading = true
            let token = decodeURIComponent(window.location.search)
                .substring(1)
                .split('confirmation_token=')[1]

            let loginCreds = { ...this.loginCreds }

            if (data.forcedPassword) {
                loginCreds.password = data.forcedPassword
            }

            if (data.forcedEmail) {
                loginCreds.email = data.forcedEmail
            }

            this.attemptLogin({ token, ...loginCreds })
                .then(() => {
                    this.handleSuccessfulLogin()
                })
                .catch((err) => {
                    this.handleUnsuccessfulLogin(err)
                })
        },
        loginAsDefault() {
            this.login({
                forcedEmail: 'arttuinthewoods@gmail.com',
                forcedPassword: document.getElementById('default-login--password').value
            })
        },
        handleSuccessfulLogin() {
            this.loading = false
            this.addNotification({
                title: 'Log In',
                text: 'Kirjauduit sisään onnistuneesti.',
                type: 'success'
            })
            this.transferToDashboard()
        },
        handleUnsuccessfulLogin(err) {
            this.loading = false
            let text
            if (err.error_description === 'No user found with that email, or password invalid.') {
                text = 'Annetuilla tiedoilla ei löytynyt käyttäjää.'
            } else if (err.error_description) {
                text = err.error_description
            }
            console.error(err)
            this.addNotification({
                title: 'Jokin meni vikaan!',
                text: text || '¯\\_(ツ)_/¯',
                type: 'fail'
            })
        },
        handleSuccessfulRecovery() {
            this.loading = false
            this.addNotification({
                title: 'Recovery',
                text: 'Kirjauduit sisään onnistuneesti.',
                type: 'success'
            })
        },
        handleUnsuccessfulRecovery(err) {
            this.loading = false
            console.error(err)
            this.addNotification({
                title: 'Jokin meni vikaan!',
                text: 'Salasanan palauttaminen epäonnistui. Palautuskoodi voi olla vanhentunut tai virheellinen.',
                type: 'fail'
            })
            this.isRecoverAccount = false
        },
        transferToDashboard() {
            this.$router.push(this.$route.query.redirectFrom || '/')
        },
        checkConfirmationToken() {
            let token = decodeURIComponent(window.location.search)
                .substring(1)
                .split('confirmation_token=')[1]
            if (token) {
                this.isVerifyEmail = true
                this.hasConfirmationToken = true
            }
        },
        checkRecoveryToken() {
            let token = decodeURIComponent(window.location.search)
                .substring(1)
                .split('recovery_token=')[1]
            if (token) {
                this.isRecoverAccount = true
                this.hasRecoveryToken = true
                this.loading = true
                this.recover(token)
            }
        }
    },
    mounted() {
        this.checkConfirmationToken()
        this.checkRecoveryToken()
    }
}
</script>

<style scoped>
.reminder {
    color: var(--font-5);
    font-size: 0.9em;
    margin-top: 2em;
    text-align: center;
}

section {
    position: relative;
}

.mb-10 {
    margin-bottom: 14em;
}

.wrapper {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    background-color: var(--bg-2);
}

.form-card {
    box-sizing: border-box;
    margin: 0 auto;
    padding: 40px;
    height: 500px;
    width: 95vw;
    max-width: 400px;
    min-width: 200px;
    background-color: var(--bg-3);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

abbr[title] {
    position: relative;

    /* ensure consistent styling across browsers */
    text-decoration: underline dotted;
}

abbr[title]:hover::after,
abbr[title]:focus::after {
    content: attr(title);

    /* position tooltip like the native one */
    position: absolute;
    left: 0;
    bottom: -20px;
    width: auto;
    white-space: nowrap;

    /* style tooltip */
    background-color: var(--bg-2);
    opacity: 0.9;
    color: black;
    border-radius: 3px;
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.4);
    font-size: 14px;
    padding: 3px 5px;
    font-size: 0.8rem;
}

input[type='password'] {
    font-size: 1.2rem;
    letter-spacing: 0.01em;
}

input[type='email']:not(:focus):invalid {
    color: red;
}

input {
    background: var(--bg-3);
    border: 2px solid var(--bg-2);
    border-radius: 4px;
    box-shadow: none;
    box-sizing: border-box;
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin: 0;
    margin-bottom: 0.5rem;
    padding: 6px 14px;
    width: 100%;
    border-radius: 8px;
    height: 44px;
    color: var(--accent-1);
    font-weight: 500 !important;
    font-family: 'Inter';
}

form li {
    display: flex;
    flex-direction: column-reverse;
}

label span {
    color: #9692a0;
    margin-bottom: 0.1rem;
}

input:focus {
    color: var(--accent-2);
    outline: none;
}

.submit-button {
    margin-top: 1em;
    font-size: 1.25em;
    background: none;
    opacity: 1;
    background-color: var(--accent-2);
    background: var(--accent-gradient);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: none;
    border-radius: 5px;
    color: #fff;
    outline: none;
    padding: 14px 3px;
    text-transform: lowercase;
    width: 100%;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 450;
}

.submit-button:focus {
    background: var(--accent-gradient-focus);
}

.eye-icon {
    cursor: pointer;
    border: none;
    background-color: transparent;
    color: var(--font-3);
    position: absolute;
    top: 44%;
    right: 8px;
    width: 26px;
    height: 26px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.95rem;
}

.eye-icon:hover {
    color: #4c4c4c;
}

.eye-icon i {
    font-size: 1.5em;
}

.sign-up-link {
    text-align: center;
    font-weight: 400;
    color: #757575;
}

.sign-up-link span {
    color: var(--accent-2);
    font-weight: 600;
    cursor: pointer;
}

@media screen and (max-width: 650px) {
    .form-card {
        height: 500px;
        padding: 30px 13px;
        width: 92vw;
    }
    section {
        margin-bottom: 1em;
    }
}
</style>
